import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
  Chip,
  Avatar,
} from "@mui/material";
import { useSnackbar } from "notistack";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Iconify from "../../components/iconify/iconify";
import CustomPopover from "../../components/custom-popover/custom-popover";
import usePopover from "../../components/custom-popover/use-popover";
import { Box } from "@mui/system";
import { useDoctorForm } from "../../data/talons/Doctor/useDoctorForm";
import { color } from "../../utils/constant";
import {
  getAreaData,
  getAreaList,
  getConsultList,
  getDoctorData,
} from "../../data/selectors/Doctor/doctorform.selector";
import { useSelector } from "react-redux";
import RHFAutocomplete from "../../components/shared/RHFAutocomplete";
/*
 * Render Real - Estate Inquiry Form screen
 *
 *
 */

export default function DoctorForm(props) {
  const { editId } = props;

  const { enqueueSnackbar } = useSnackbar();
  const editItem = useSelector(getDoctorData);

  const areaList = useSelector(getAreaList);
  const consultList = useSelector(getConsultList);

  const {
    loader,
    loading,
    status,
    areaId,
    consultId,
    doctorEntrySchema,
    handleStatusComboChange,
    doctorEntry,
    doctorUpdate,
    handleFileChange,
    findAreaFromLabel,
    fetchAreaComboList,
    findConsultFromLabel,
    fetchConsultComboList,
    getDoctorbyId,
  } = useDoctorForm({
    existingStatus: get(editItem, "status", 0),
    existingImageUrl: { url: get(editItem, "image_url", "") },
    existingArea: get(editItem, "area_id", []),
    existingConsult: get(editItem, "consult_id", []),
    existingAreaId:
      size(editItem?.area_id) > 0 ? JSON.parse(editItem?.area_id) : [],
    existingConsultId:
      size(editItem?.consult_id) > 0 ? JSON.parse(editItem?.consult_id) : [],
  });

  const popover = usePopover();
  const [imageData, setImageData] = useState(
    size(editItem?.image_url) == 0 ? null : editItem.image_url
  );

  const defaultValues = useMemo(() => ({
    name: get(editItem, "name", ""),
    speciality: get(editItem, "speciality", ""),
    experience: get(editItem, "experience", ""),
    slot_timing: String(get(editItem, "slot_timing", "")),
    biography: get(editItem, "biography", ""),
    location_url: get(editItem, "location_url", ""),
    working_time: get(editItem, "working_time", ""),
    area_name:
      size(editItem?.area_list) > 0 ? JSON.parse(editItem?.area_list) : [],
    consult_name:
      size(editItem?.consult_list) > 0
        ? JSON.parse(editItem?.consult_list)
        : [],
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
    setValue,
  } = useForm({
    resolver: joiResolver(doctorEntrySchema),
    defaultValues,
  });

  useEffect(() => {
    fetchAreaComboList();
    fetchConsultComboList();
    getDoctorbyId(editId);
  }, []);

  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/^0|[^0-9.]/g, "");

    if (e.target.value.toString().length === 0) return;
    return (e.target.value = e.target.value.slice(0, 10));
  };
  // //Validation UseEffect
  // useEffect(() => {
  //   if (errors?.reference_source) {
  //     enqueueSnackbar(errors.reference_source.message, {
  //       variant: 'error',
  //     });
  //     return;
  //   }
  // }, [errors]);

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await doctorEntry({
              ...getValues(),
            })
          : await doctorUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Doctor Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [doctorEntry, doctorUpdate]);

  const onlyCharacters = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]*$/, "");

    return e.target.value;
  };

  const fileUpload = (file) => {
    handleFileChange(file);
    popover.onClose();
    const reader = new FileReader();

    reader.onload = () => {
      setImageData(reader.result);
    };

    reader.readAsDataURL(file);
  };

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Doctor Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container gap={3}>
        {/* First Grid: Image Section (4 columns) */}
        <Grid item xs={4} sm={3}>
          {imageData === null ? (
            <IconButton
              className="p-0"
              style={{ width: "100%", borderRadius: "50%" }}
              color="primary"
            >
              <label
                htmlFor="upload"
                onMouseEnter={(e) => (e.target.style.padding = "1rem")}
                style={{
                  width: "100%",
                  height: "260px",
                  border: "2px dashed #1976d2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                }}
              >
                <>
                  <AddAPhotoIcon style={{ fontSize: "3rem" }} />
                  <input
                    accept="image/*"
                    onChange={(e) => fileUpload(e.target.files[0])}
                    type="file"
                    hidden={true}
                    id="upload"
                  />
                </>
              </label>
            </IconButton>
          ) : (
            <Grid
              item
              xs={12}
              sm={12}
              sx={{ width: "100%", textAlign: "center" }}
            >
              <div>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <IconButton className="iconbtn" onClick={popover.onOpen}>
                    <Iconify icon="eva:more-vertical-fill" />
                  </IconButton>
                </Box>

                <Avatar
                  alt="Image"
                  src={imageData}
                  sx={{
                    height: "350px",
                    width: "300px",
                    textAlign: "center",
                    objectFit: "cover", // Ensures the image covers the entire avatar without distorting it
                    objectPosition: "center",
                  }}
                />
                {/* <img
                  className="uploadedImg"
                  src={imageData}
                  style={{
                    width: "100%",
                    height: "20%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                  }}
                /> */}

                <CustomPopover
                  open={popover.open}
                  onClose={popover.onClose}
                  arrow="right-top"
                  sx={{ width: 100, ml: 1, marginTop: "30px" }}
                >
                  <IconButton
                    style={{
                      width: "100%",
                      borderRadius: "0px",
                      fontSize: "16px",
                      fontWeight: "normal",
                    }}
                    color="primary"
                    sx={{ padding: 0 }}
                  >
                    <label
                      htmlFor="uploadagain"
                      style={{
                        width: "100%",
                        padding: 7,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Iconify icon="solar:pen-bold" />
                          <span style={{ marginLeft: "10px" }}>Edit</span>
                        </div>

                        <input
                          className="uploadInput"
                          accept="image/*"
                          onChange={(e) => fileUpload(e.target.files[0])}
                          type="file"
                          hidden={true}
                          id="uploadagain"
                        />
                      </div>
                    </label>
                  </IconButton>
                  <div
                    onClick={() => setImageData(null)}
                    style={{
                      display: "flex",
                      marginLeft: "5px",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "red",
                    }}
                  >
                    {/* <Iconify icon="solar:trash-bin-trash-bold" />
                    <span style={{ marginLeft: "10px" }}>Delete</span> */}
                  </div>
                </CustomPopover>
              </div>
            </Grid>
          )}
        </Grid>

        {/* Second Grid: Form Section (8 columns) */}
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2}>
            {/* First Row: 6 columns each for Name and Speciality */}
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="name"
                name="name"
                label="Doctor Name"
                fullWidth
                variant="outlined"
                size="small"
                onInput={(e) => onlyCharacters(e)}
                inputProps={{
                  maxLength: 50,
                }}
                {...register("name")}
                autoComplete="false"
                error={size(errors?.name?.message) > 0}
                helperText={
                  size(errors?.name?.message) > 0 ? errors?.name?.message : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="speciality"
                name="speciality"
                label="Speciality"
                onInput={(e) => onlyCharacters(e)}
                fullWidth
                variant="outlined"
                size="small"
                inputProps={{
                  maxLength: 50,
                }}
                {...register("speciality")}
                autoComplete="false"
                error={size(errors?.speciality?.message) > 0}
                helperText={
                  size(errors?.speciality?.message) > 0
                    ? errors?.speciality?.message
                    : ""
                }
              />
            </Grid>

            {/* Second Row: 6 columns for Experience */}
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="experience"
                name="experience"
                label="Experience"
                onInput={(e) => onlyNumbers(e)}
                fullWidth
                variant="outlined"
                size="small"
                inputProps={{
                  maxLength: 3,
                }}
                {...register("experience")}
                autoComplete="false"
                error={size(errors?.experience?.message) > 0}
                helperText={
                  size(errors?.experience?.message) > 0
                    ? errors?.experience?.message
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="slot_timing"
                name="slot_timing"
                label="Slot Timing(In Min)"
                onInput={(e) => onlyNumbers(e)}
                fullWidth={true}
                variant="outlined"
                size="small"
                inputProps={{
                  maxLength: 2,
                }}
                {...register("slot_timing")}
                autoComplete="false"
                error={size(errors?.slot_timing?.message) > 0 ? true : false}
                helperText={
                  size(errors?.slot_timing?.message) > 0
                    ? errors?.slot_timing?.message
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                required
                id="working_time"
                name="working_time"
                label="Working Time"
                fullWidth
                variant="outlined"
                size="small"
                inputProps={{
                  maxLength: 500,
                }}
                {...register("working_time")}
                autoComplete="false"
                error={size(errors?.working_time?.message) > 0}
                helperText={
                  size(errors?.working_time?.message) > 0
                    ? errors?.working_time?.message
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <RHFAutocomplete
                // borderRadius={"12px"}
                multiple
                isRequired={true}
                name="area_name"
                label="Area Name"
                freeSolo
                data={areaList || []}
                defaultValue={areaId}
                onInputChange={(value) => findAreaFromLabel(value)}
                id={areaList?.map((option) => option.id)}
                renderOption={(props, option) => (
                  <>
                    <li {...props} key={option}>
                      {option}
                    </li>
                  </>
                )}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option}
                      label={option}
                      size="small"
                      color="info"
                      variant="soft"
                    />
                  ))
                }
                control={control}
                setValue={setValue}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <RHFAutocomplete
                // borderRadius={"12px"}
                multiple
                isRequired={true}
                name="consult_name"
                label="Consult Name"
                freeSolo
                data={consultList || []}
                defaultValue={consultId}
                onInputChange={(value) => findConsultFromLabel(value)}
                id={consultList?.map((option) => option.id)}
                renderOption={(props, option) => (
                  <>
                    <li {...props} key={option}>
                      {option}
                    </li>
                  </>
                )}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option}
                      label={option}
                      size="small"
                      color="info"
                      variant="soft"
                    />
                  ))
                }
                control={control}
                setValue={setValue}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                required
                id="location_url"
                name="location_url"
                label="Location Url"
                onInput={(e) => onlyCharacters(e)}
                fullWidth={true}
                variant="outlined"
                size="small"
                inputProps={
                  {
                    //maxLength: 500,
                  }
                }
                {...register("location_url")}
                autoComplete="false"
                error={size(errors?.location_url?.message) > 0 ? true : false}
                helperText={
                  size(errors?.location_url?.message) > 0
                    ? errors?.location_url?.message
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id="biography"
                name="biography"
                label="Biography"
                onInput={(e) => onlyCharacters(e)}
                fullWidth={true}
                multiline={true}
                minRows={2}
                variant="outlined"
                size="small"
                inputProps={
                  {
                    //maxLength:500,
                  }
                }
                {...register("biography")}
                autoComplete="false"
                error={size(errors?.biography?.message) > 0 ? true : false}
                helperText={
                  size(errors?.biography?.message) > 0
                    ? errors?.biography?.message
                    : ""
                }
              />
            </Grid>

            <Grid item xs={3} sm={3}>
              <Typography>
                <FormControlLabel
                  sx={{ mt: -1 }}
                  control={
                    <Checkbox
                      sx={{
                        "&.Mui-checked": {
                          color: color.button,
                        },
                      }}
                      id="is_labour"
                      checked={status}
                      onChange={handleStatusComboChange}
                    />
                  }
                  label="Active"
                />
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
